/** Mirror of packing-label-service/evaluate-abv-label.js */
export default function evaluateAbvLabel({ abv, abvMin, abvMax }) {
  const abvIsRange = abvMin !== null || abvMax !== null;

  if (abv === null && !abvIsRange) {
    return 'N/A';
  }

  return (abv !== null ? (
    `${abv}%`
  ) : (
    `${abvMin === null ? '?' : `${abvMin}%`} - ${abvMax === null ? '?' : `${abvMax}%`}`
  ));
}
